import BaseXMLGenerator from './xlsx-tableexport-generator.js';
import '@/data/filters/formatter.js';

var XMLGenerator = new BaseXMLGenerator();
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas) {
    var rows = []
    for (var data of datas) {
        var row = []
        row.push(data.Profile.Name)
        row.push(data.Username)

        let position = vm.$store.getters.userPositions.find(o => o.UserID == data.ID) || {};
        let level = (function () {
            if (position.Level === 1) return "員工";
            if (position.Level === 10) return "主管";
            if (position.Level === 100) return "會計";
            if (position.Level === 1000) return "總經理";
            if (position.Level === 10000) return "蝦董";
            if (position.Level === 100000) return "工程師";
            return position.Level;
        })()
        let department = (function () {
            let departmentID = (
                vm.$store.getters.userDepartments.find(o => o.UserID == data.ID) || {}
            ).DepartmentID;
            if (!departmentID) return null;
            return vm.$store.getters.departments.find(o => o.ID == departmentID);
        })()
        let leftCompensatory = (function () {
            if (position.Level >= 10) return null
            let hours = vm.$store.state.compensatoryTime.list.filter(o => o.UserID == data.ID).reduce((sum,o)=>sum+((o.Status=='通過' || o.LeaveFormID > 0)?o.Hours : 0), 0)
            return `${hours/8}天`
        })()

        row.push((department && department.Name) || '')
        row.push(level)
        row.push(leftCompensatory)
        rows.push(row)
    }
    let headerList = ['人員名稱', '帳號', '部門', '職位', '剩餘補休']
    return this.baseGenerate(rows, headerList)
}

export default XMLGenerator;